import { render, staticRenderFns } from "./PatientReportedOutcome.vue?vue&type=template&id=316e8f32&"
import script from "./PatientReportedOutcome.vue?vue&type=script&lang=js&"
export * from "./PatientReportedOutcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports